var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.formTitle)+": "+_vm._s(_vm.status ? _vm.$t("profile.reception") : _vm.$t("profile.receptionStop"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }